export default __webpack_public_path__ + "static/media/Burger.302be27a.webp";